import { useCallback } from 'react';
import { useNotificationStore } from '../../../Notification.store';
export const useOnClose = (id) => {
    const store = useNotificationStore();
    const onClose = useCallback(() => store.removeNotification(id), [id, store.removeNotification]);
    return onClose;
};
